import { DocContent } from '../docsData';

const doc: DocContent = {
  title: 'Exports',
  content: `
## Overview

Exports (formerly "Reports") allow you to expose governed data from Pliable to external tools via Snowflake. Use this feature to:

- Create curated datasets for BI tools (Power BI, Tableau)
- Sync cleaned data to operational systems (Salesforce, HubSpot)
- Share analytics-ready tables with stakeholders

---

## Key Concepts

### Datasets

**Purpose**: Model Pliable data as Snowflake tables/views

- **Source**: Entities, metrics, or cleaned data from Pliable
- **Output**: Snowflake tables updated automatically
- **Use Case**: "I need a customer table for our Looker dashboards."

### Destinations

**Purpose**: Push Pliable data to external systems

- **Supported**: CRMs, marketing tools, databases
- **Output**: Scheduled syncs to external APIs
- **Use Case**: "Send cleaned lead data to Salesforce nightly."

---

## How to Create an Export

### Step 1: Create a Dataset

1. Go to **Exports > + New Dataset**

2. Configure:
   - **Name**: e.g., \`Sales_Customers\`
   - **Data Source**: Select from Semantic Layer entities
   - **Columns**: Choose dimensions/metrics (e.g., Customer_Name, LTV)
   - **Refresh Schedule**: Hourly/Daily/Weekly

3. Click **Build** to publish to Snowflake

> 💡 Tip: Datasets appear as \`PLIABLE_<YOUR_DATASET_NAME>\` in Snowflake

### Step 2: Set Up a Destination

1. Go to **Exports > + New Destination**

2. Configure:
   - **Integration**: Select service (e.g., Salesforce, HubSpot)
   - **Dataset**: Choose your Pliable dataset
   - **Field Mapping**: Map columns (e.g., Email to Contact_Email)
   - **Sync Frequency**: Set automation rules

3. Click **Activate**

---

## Advanced Features

Define columns and refresh schedules for Snowflake exports.

---

## Troubleshooting

**Issue**: "No nodes found" in Exports

**Solution**:
1. Ensure you've built at least one entity in the Semantic Layer
2. Check Snowflake permissions for the PLIABLE database

**Issue**: Sync failures to destinations

**Solution**:
- Verify API keys in **Settings > Integrations**
- Check field mapping compatibility (e.g., date formats)

A warning status could indicate:
- Warning if the entity has no relationships to other entities (entity only)
- Warning if it's a cleaning step or entity and has no source nodes
- Error if the last time a build was run, the node had a build error
`,
};

export default doc;
